// src/lib/roles.js
//
// Matrice ruoli (Specifica v1.1 §4.2):
// - HR: target, longlist, inviti, risorse, esperienze, stato SA
// - Sales: Knowledge Layer, modifica redazionale, marcatura commerciale
// - Management: Knowledge Layer e modifica redazionale, NESSUN accesso alle rotte HR
// - Admin: accesso amministrativo completo
//
// L'ACL su validate/sales-mark non è del tutto esplicita nel catalogo
// endpoint (segnata "JWT/ACL"), quindi le regole sotto sono un'INTERPRETAZIONE
// ragionevole basata sugli use case (UC-KM-03 assegna la marcatura a Sales),
// non una certezza contrattuale — da confermare con Monaco/prodotto.

export const ROLES = {
  HR: 'hr',
  SALES: 'sales',
  MANAGEMENT: 'management',
  ADMIN: 'admin',
};

export const ROLE_LABELS = {
  [ROLES.HR]: 'HUB HR',
  [ROLES.SALES]: 'Sales',
  [ROLES.MANAGEMENT]: 'Management',
  [ROLES.ADMIN]: 'Admin',
};

export function canManageEsperienze(role) {
  // Apertura, modifica data prevista, chiusura: solo HR (rotte HR, §4.2)
  return role === ROLES.HR || role === ROLES.ADMIN;
}

export function canEditScheda(role) {
  // PATCH /schede/{id} è documentato per "HR/Sales/Mgmt" (Appendice A)
  return [ROLES.HR, ROLES.SALES, ROLES.MANAGEMENT, ROLES.ADMIN].includes(role);
}

export function canSalesMark(role) {
  // UC-KM-03: "Come Sales, voglio marcare una scheda..." — azione di Sales
  return role === ROLES.SALES || role === ROLES.ADMIN;
}

export function canViewKnowledgeManagement() {
  // Tutti i ruoli autenticati possono consultare (§4.2)
  return true;
}
